import axios from "axios";

const apiClient = axios.create({
  //baseURL: "http://localhost:5090/api",
  baseURL: "/api",
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use((config) => {
  // 1. Προσθήκη του Token (όπως το είχες)
  const user = localStorage.getItem("user");
  if (user) {
    const { token } = JSON.parse(user);
    config.headers.Authorization = `Bearer ${token}`;
  }

  const deviceName =
    localStorage.getItem("deviceName") || navigator.userAgent || "Web Browser";
  config.headers["X-Device-Name"] = deviceName;

  // FormData needs the browser to set multipart/form-data with boundary.
  // The default application/json Content-Type would break file uploads.
  if (typeof FormData !== "undefined" && config.data instanceof FormData) {
    if (config.headers && typeof config.headers.delete === "function") {
      config.headers.delete("Content-Type");
    } else if (config.headers) {
      delete (config.headers as Record<string, unknown>)["Content-Type"];
    }
  }

  return config;
});

apiClient.interceptors.response.use(
  (response) => response.data,
  (error) => Promise.reject(error),
);

export default apiClient;
